import { useNavigate } from "react-router-dom";
import { FaUserPlus,FaGraduationCap,FaList,FaBullhorn,FaCalendarAlt, FaSchool, FaChalkboardTeacher,FaUserCircle } from "react-icons/fa";


export default function ModuleMenu() {

  const navigate = useNavigate();

  const menus = [
    { title: "Users", path: "/dashboard/users", icon: <FaUserCircle size={28}/> },
    { title: "Academic Students", path: "/dashboard/studentAcademics", icon: <FaGraduationCap size={28}/> },
    { title: "Classes", path: "/dashboard/class", icon: <FaSchool size={28}/> },
    { title: "Catalogs", path: "/dashboard/catalogs", icon: <FaList size={28}/> },
    { title: "Admissions", path: "/dashboard/admissions", icon: <FaUserPlus size={28}/> },
    { title: "Holidays", path: "/dashboard/holidays", icon: <FaCalendarAlt size={28}/> },
    { title: "Notices", path: "/dashboard/announcements", icon: <FaBullhorn size={28}/> },
    { title: "Teacher-Class Mapping", path: "/dashboard/facultyMap", icon: <FaChalkboardTeacher  size={28}/> },
  ];

  return (
    <div className="p-4 md:p-8">

      <h1 className="text-xl md:text-2xl font-semibold mb-6">
        Academic Management
      </h1>

      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-4">

        {menus.map((menu, index) => (
          <div
            key={index}
            onClick={() => navigate(menu.path)}
            className="bg-white rounded-xl shadow hover:shadow-lg cursor-pointer 
                       flex flex-col items-center justify-center 
                       p-6 transition transform hover:-translate-y-1"
          >

            <div className="text-blue-600 mb-2">
              {menu.icon}
            </div>

            <span className="text-sm md:text-base font-medium text-center">
              {menu.title}
            </span>

          </div>
        ))}

      </div>

    </div>
  );
}